export const reports = [
  {
    path: '/reports',
    name: 'reports',
    component: () => import('./reports.vue'),
    meta: {
      rule: 'REPORTS',
      authRequired: true,
      title: 'general.reports',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/',
        },
        {
          text: 'general.reports',
          disabled: true,
          href: '#/',
        }
      ]
    }
  },
  {
    path: '/reports/inspectionUnitTypes',
    name: 'reports',
    component: () => import('./inspectionsAndUnitTypes.vue'),
    meta: {
      rule: 'REPORTS',
      authRequired: true,
      title: 'general.reports',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/',
        },
        {
          text: 'general.reports',
          disabled: true,
          href: '#/',
        },
        {
          text: 'reports.inspectionUnitTypes',
          disabled: true,
          href: '#/',
        }
      ]
    }
  },
  {
    path: '/inspectionUnitTypes/view/:id',
    name: 'reportViewInspection',
    component: () => import('../inspections/form.vue'),
    meta: {
      rule: 'REPORTS',
      authRequired: true,
      title: 'inspections.view',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/'
        },
        {
          text: 'general.reports',
          disabled: true,
          href: '#/',
        },
        {
          text: 'reports.inspectionUnitTypes',
          disabled: false,
          href: '#/reports/inspectionUnitTypes',
        },
        {
          text: 'inspections.view',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/reports/inspectionReportInspector',
    name: 'reports',
    component: () => import('./inspectionInspector.vue'),
    meta: {
      rule: 'REPORTS',
      authRequired: true,
      title: 'general.reports',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/',
        },
        {
          text: 'general.reports',
          disabled: true,
          href: '#/',
        },
        {
          text: 'reports.inspectionReportInspector',
          disabled: true,
          href: '#/',
        }
      ]
    }
  },
  {
    path: '/reports/incidentsInspector',
    name: 'reports',
    component: () => import('./incidentsInspector.vue'),
    meta: {
      rule: 'REPORTS',
      authRequired: true,
      title: 'general.reports',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/',
        },
        {
          text: 'general.reports',
          disabled: true,
          href: '#/',
        },
        {
          text: 'reports.incidentsInspector',
          disabled: true,
          href: '#/',
        }
      ]
    }
  },
  {
    path: '/reports/inspectionsUnitType',
    name: 'reports',
    component: () => import('./inspectionsUnitType.vue'),
    meta: {
      rule: 'REPORTS',
      authRequired: true,
      title: 'general.reports',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/',
        },
        {
          text: 'general.reports',
          disabled: true,
          href: '#/',
        },
        {
          text: 'reports.incidentsUnitType',
          disabled: true,
          href: '#/',
        }
      ]
    }
  },
  {
    path: '/reports/checklistReport',
    name: 'reports',
    component: () => import('./checklistReport.vue'),
    meta: {
      rule: 'REPORTS',
      authRequired: true,
      title: 'general.reports',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/',
        },
        {
          text: 'general.reports',
          disabled: true,
          href: '#/',
        },
        {
          text: 'reports.checklistReport',
          disabled: true,
          href: '#/',
        }
      ]
    }
  },
  {
    path: '/reports/inspectionPointsWithDamages',
    name: 'reports',
    component: () => import('./inspectionPointsWithDamages.vue'),
    meta: {
      rule: 'REPORTS',
      authRequired: true,
      title: 'general.reports',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/',
        },
        {
          text: 'general.reports',
          disabled: true,
          href: '#/',
        },
        {
          text: 'reports.inspectionPointsWithDamages',
          disabled: true,
          href: '#/',
        }
      ]
    }
  },
  {
    path: '/reports/operatorsWithDamages',
    name: 'reports',
    component: () => import('./operatorsWithDamages.vue'),
    meta: {
      rule: 'REPORTS',
      authRequired: true,
      title: 'general.reports',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/',
        },
        {
          text: 'general.reports',
          disabled: true,
          href: '#/',
        },
        {
          text: 'reports.operatorsWithDamage',
          disabled: true,
          href: '#/',
        }
      ]
    }
  },
  {
    path: '/reports/inspectionCountByUnit',
    name: 'reports',
    component: () => import('./inspectionCountByUnit.vue'),
    meta: {
      rule: 'REPORTS',
      authRequired: true,
      title: 'general.reports',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/',
        },
        {
          text: 'general.reports',
          disabled: true,
          href: '#/',
        },
        {
          text: 'reports.inspectionCountByUnit',
          disabled: true,
          href: '#/',
        }
      ]
    }
  },
  {
    path: '/reports/inspectionCountByUnit/view/:id',
    name: 'reportCountByUnitViewInspection',
    component: () => import('../inspections/form.vue'),
    meta: {
      rule: 'REPORTS',
      authRequired: true,
      title: 'inspections.view',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/'
        },
        {
          text: 'general.reports',
          disabled: true,
          href: '#/',
        },
        {
          text: 'reports.inspectionCountByUnit',
          disabled: false,
          href: '#/reports/inspectionCountByUnit',
        },
        {
          text: 'inspections.view',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/reports/tireChangeReport',
    name: 'reports',
    component: () => import('./tireChangeReport.vue'),
    meta: {
      rule: 'REPORTS',
      authRequired: true,
      title: 'general.reports',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/',
        },
        {
          text: 'general.reports',
          disabled: true,
          href: '#/',
        },
        {
          text: 'reports.tireChangeReport',
          disabled: true,
          href: '#/',
        }
      ]
    }
  },
  {
    path: '/reports/tireChangeReport/view/:id',
    name: 'reportTireChangeViewInspection',
    component: () => import('../inspections/form.vue'),
    meta: {
      rule: 'REPORTS',
      authRequired: true,
      title: 'inspections.view',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/'
        },
        {
          text: 'general.reports',
          disabled: true,
          href: '#/',
        },
        {
          text: 'reports.tireChangeReport',
          disabled: false,
          href: '#/reports/tireChangeReport',
        },
        {
          text: 'inspections.view',
          disabled: true
        }
      ]
    }
  }
]